import cn from 'classnames';

export const tableUtilIconsClassName = cn(
  'text-3color transition hover:text-action cursor-pointer transition cursor-pointer',
);
